import { Skeleton } from 'primereact/skeleton';

interface DataTableLoadingProps {
  // Minimal shape used by this component; other fields (if any) are ignored
  options: {
    cellEven?: boolean;
    field?: string;
    // Allow arbitrary extra properties without tightening callers
    [key: string]: unknown;
  };
}

const DataTableLoading: React.FC<DataTableLoadingProps> = ({ options }) => {
  return (
    <div
      className='flex align-items-center'
      style={{ height: '17px', flexGrow: '1', overflow: 'hidden' }}
    >
      <Skeleton
        width={
          options.cellEven ? (options.field === 'year' ? '30%' : '40%') : '60%'
        }
        height='1rem'
      />
    </div>
  );
};

export default DataTableLoading;
